import { Typography } from "@mui/material";
import React from "react";
import type { SvgIconComponent } from "@mui/icons-material";
import { CardButton } from "./CardButton.styled";

interface TextIconButtonProps {
  /** Omit entirely for a plain action button; pass a boolean to make it a toggle. */
  isSelected?: boolean;
  text: string;
  onClick: () => void;
  icon?: SvgIconComponent;
  sx?: object;
  disabled?: boolean;
}

const ICON_SIZE = "18px";

const TextIconButton: React.FC<TextIconButtonProps> = ({ isSelected, text, onClick, icon, sx, disabled }) => {
  const MuiIcon = icon;

  return (
    <CardButton $selected={isSelected} aria-pressed={isSelected} onClick={onClick} disabled={disabled} disableRipple>
      {MuiIcon && <MuiIcon sx={{ mb: "3px", fontSize: ICON_SIZE, ...sx }} />}
      <Typography sx={{ fontSize: "12px", fontWeight: 700, lineHeight: "20px" }}>{text}</Typography>
    </CardButton>
  );
};

export default TextIconButton;
